/*
 * @Description: 地理（geo）— F1 搜索 / F3 反解 本地 mock（阶段二添加点位选点用）。
 */
import { GeocodeResult, GeoSearchData, RegeoResult } from '../types/poi.types'

/** F1 /geo/search mock（对齐设计图「天府大道」搜索结果） */
export const MOCK_GEO_SEARCH: GeoSearchData = {
  items: [
    { name: '天府大道北段128号', address: '', lng: 104.066801, lat: 30.572816 },
    { name: '天府大道中段688号', address: '', lng: 104.06309, lat: 30.54692 },
    { name: '天府大道南段2039号', address: '', lng: 104.07125, lat: 30.4988 },
    { name: '天府大道北段1700号', address: '', lng: 104.0625, lat: 30.5563 }
  ]
}

/** F3 /geo/regeo mock */
export const MOCK_REGEO: RegeoResult = {
  address: '四川省成都市高新区天府大道北段128号',
  province: '四川省',
  city: '成都市',
  district: '高新区'
}

/** F2 /geo/geocode mock（地址→坐标，批量导入解析地址用） */
export const MOCK_GEOCODE: GeocodeResult = {
  lng: 104.0668,
  lat: 30.5728,
  address: '四川省成都市高新区天府大道北段128号'
}
